<template>
  <div class="container">
    <vx-card title="Editar catálogo">
      <vs-table stripe search :max-items="30" :data="catalog.items">
        <template slot="header">
          <vs-button @click="showNewElementDialog = true" class="float-right mb-2">
            Nuevo Elemento
          </vs-button>
        </template>
        <template slot="thead">
          <vs-th>Elemento</vs-th>
          <vs-th>Valor</vs-th>
          <vs-th>Opciones</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="item in data">
            <vs-td>{{ item.description }}</vs-td>
            <vs-td>{{ item.percentage }}</vs-td>
            <vs-td>
              <vs-button color="dark">
                Editar
              </vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <vs-popup :active.sync="showNewElementDialog" title="Nuevo elemento">
      <vs-input v-model="form.itemName" label="Elemento" class="w-full"></vs-input>
      <vs-input v-model="form.value" label="Valor" class="w-full mt-2"></vs-input>

      <vs-button @click="saveElementHandle" class="mt-4">
        Guardar
      </vs-button>
    </vs-popup>
  </div>
</template>
<script>
export default {
  name: "RiskModelCatalogEditor",
  data: () => ({
    catalog: {},
    form: {
      itemName: '',
      value: 0
    },
    showNewElementDialog: false
  }),
  async mounted() {
    this.$vs.loading();
    try {
      const {data} = await axios.get("/api/risk-model/catalog/" + this.$route.params.id)
      this.catalog = data;
      this.$vs.loading.close();
    } catch (e) {
      this.$vs.loading.close();
    }
  },
  methods: {
    saveElementHandle() {
      this.$vs.loading();
      axios.post("/api/risk-model/catalog", {
        category: this.catalog.category,
        description: this.form.itemName,
        value: this.form.value
      }).then((response) => {
        this.$vs.loading.close();
        this.catalog.items.push(response.data);
        this.showNewElementDialog = false;
      }).catch(() => {
        this.$vs.loading.close();
      })
    }
  }
}
</script>
<style scoped>

</style>